import { useGetMemberHeader } from 'common/queries/member-module';
import { useGetMemberId } from './useGetMemberId';

export const useGetMemberInfo = () => {
  const { memberId } = useGetMemberId();

  const {
    data: memberInfo,
    isLoading,
    isFetching,
  } = useGetMemberHeader(
    {
      memberId,
    },
    {
      enabled: Boolean(memberId),
    }
  );

  return { memberInfo, isLoading, isFetching };
};
